import React from 'react';

const Inventory = () => {
   return (
      <div>

      <h1>Cart details is comming</h1>
         
      </div>
   );
};

export default Inventory;